(function () {
  function setup(section) {
    if (!('IntersectionObserver' in window)) return;
    if (section.classList.contains('ab-anim')) return; // avoid double init
    section.classList.add('ab-anim');

    var targets = [];
    var heading = section.querySelector('.about-custom__heading');
    if (heading) targets.push(heading);

    // Each row triggers independently; its image + paragraph reveal with stagger
    section.querySelectorAll('.about-custom__row').forEach(function (row) {
      targets.push(row);
    });

    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initAll() {
    document.querySelectorAll('.about-custom').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.about-custom');
    if (section) setup(section);
  });
})();
